import React from 'react';

import MultipleTestimonialsSection, {
  Testimonial,
} from '@zego/components/molecules/MultipleTestimonialsSection';

import FlintInsurance from '@zego/static/images/FlintInsurance.png';
import Aldium from '@zego/static/svgs/Aldium.svg';

const TESTIMONIALS_COPY: Array<Testimonial> = [
  {
    id: 'broker-aldium',
    image: Aldium,
    alt: 'Aldium logo',
    text: `We've been continually impressed  by Zego over the past 12 months. The process has been simple, easy and effective, resulting in great cost savings for our clients on what is their largest annual spend!`,
    customer: '- Paul Davies, Transportation Manager at Aldium',
  },
  {
    id: 'broker-flint-insurance',
    image: FlintInsurance,
    alt: 'Flint Insurance logo',
    text: `The way that we work with Zego is seamless; the portal allows both us and the client to administer the policy online and there's a great team there in the background to help whenever we might need it.`,
    customer: '- Ian Leigh, Associate Director of Flint Insurance',
  },
];

export default function BrokerLandingPageTestimonials(): JSX.Element {
  return (
    <MultipleTestimonialsSection
      heading="What our Broker partners say"
      testimonials={TESTIMONIALS_COPY}
    />
  );
}
